import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { UserPermissionsService } from "../services/user-permissions.service";

export const PermissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const userPermissionsService = inject(UserPermissionsService);
  const menuName = route.data?.["menu"];
  const permissionName = route.data?.["permission"];
  const permissionNames = route.data?.["permissions"] as string[] | undefined;

  if (!menuName && !permissionName && !permissionNames?.length) {
    return true;
  }

  return userPermissionsService.loadCurrentUserPermissions().pipe(
    map(() => {
      const hasMenuAccess = !menuName || userPermissionsService.hasMenu(menuName);
      const hasPermissionAccess = !permissionName || userPermissionsService.hasPermission(permissionName);
      const hasAnyPermissionAccess = !permissionNames?.length || userPermissionsService.hasAnyPermission(permissionNames);

      if (hasMenuAccess && hasPermissionAccess && hasAnyPermissionAccess) {
        return true;
      }

      console.warn("[PERMISSIONS] Acceso denegado:", {
        menu: menuName,
        permission: permissionName,
        permissions: permissionNames,
      });
      return router.createUrlTree(["/access-denied"]);
    }),
    catchError((error) => {
      console.error("[PERMISSIONS] Error validando permisos de ruta:", error);
      return of(router.createUrlTree(["/access-denied"]));
    })
  );
};
